export default "__VITE_ASSET__LpWbTuIU__"